import { useQueryClient } from '@tanstack/svelte-query';
import { type LiveStatus, startLiveStream } from './stream';

export type { LiveStatus } from './stream';

/**
 * Live updates over SSE (ADR-019; the connection, its reconnects and its watchdog are in stream.ts).
 * Call while a component initializes.
 */
export function liveUpdates(orgId: () => string, enabled: () => boolean): { readonly status: LiveStatus } {
  const qc = useQueryClient();
  let status = $state<LiveStatus>('connecting');

  $effect(() => {
    const org = orgId();
    if (!enabled()) return;
    return startLiveStream({ orgId: org, queryClient: qc, onStatus: (s) => (status = s) });
  });

  return {
    get status() {
      return status;
    },
  };
}
